import type { DataItem } from '@pn/core/domain/data';
import { useBuildSliceSelector } from '@pn/services/redux/useBuildSliceSelector';
import { isNil } from 'lodash-es';
import { store } from 'src/application/storage/store';
import { companiesOverviewSlice } from './companiesOverviewSlice';

export const useCompaniesOverviewStorage = () => {
  const { name, getInitialState } = companiesOverviewSlice;

  const useSliceSelector = useBuildSliceSelector(name, getInitialState());

  return {
    isFetching: useSliceSelector((state) => state.isFetching),
    isError: useSliceSelector((state) => state.isError),
    stats: useSliceSelector((state) => state.stats),
    shouldLoadStats: useSliceSelector((state) => state.shouldLoadStats),
  };
};

export const companiesOverviewActions = () => {
  const { dispatch, getState } = store;
  const { actions, name } = companiesOverviewSlice;

  if (isNil(getState()[name])) {
    throw new Error(`[${name}] reducer has not been injected yet`);
  }

  return {
    receive: (stats: DataItem[]) => dispatch(actions.receive(stats)),
    request: () => dispatch(actions.request()),
    error: () => dispatch(actions.error()),
    reset: () => dispatch(actions.reset()),
  };
};
